<template>
  <div>
    <dx-data-grid ref='refFileControl'
      :data-source='fileListInfo'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeightFile' :row-alternation-enabled="true"
      keyExpr="seqId" :focusedRowEnabled="true" :focused-row-key.sync='focusedRowKeyFile'
      :auto-navigate-to-focused-row="true" @focused-row-changed="onFocusedRowChangedFile"
      @row-removed='onRowRemovedFile' @row-inserted='onRowInsertedFile' @row-inserting='onRowInsertingFile'
      @init-new-row='onInitNewRowFile' @toolbarPreparing="onToolbarPreparingFile"
    >
      <DxSearchPanel
        :visible="false"
        placeholder="검색..."
      />
      <DxExport
        :enabled="false"
        file-name="거래처정보"
      />
      <DxFilterRow
        :visible="false"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="isCRUDFile"
        :allow-updating="false"
        :allow-adding="false"
        :use-icons="true"
        mode='row'
      >
      </DxEditing>
      <DxColumnFixing :enabled="true"/>
      <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="유형"
        data-field="첨부파일유형"
        alignment="center"
        :width="200"
      >
        <DxRequiredRule message="항목을 입력하세요"/>
      </DxColumn>
      <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="첨부파일명"
        data-field="첨부파일명"
        alignment="left"
        :min-width="100"
        >
      </DxColumn>
      <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="저장파일명"
        data-field="저장파일명"
        alignment="left"
        :min-width="200"
      >
      </DxColumn>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <input id="file-upload-input" class="inputFile" type="file" name="file" @change="onFileChange" accept="" style="display: none;">

  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxPaging, DxScrolling,
  DxColumn, DxSorting, DxEditing, DxSearchPanel } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import FileService from '../service/FileService'
import HttpService from '../service/HttpService'

export default {
  name: 'fileUploadComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: this.$store.getters.getUserInfo,
      focusedRowKeyFile: null,
      selectedRowFile: null
    }
  },
  props: {
    fileListInfo: {
      type: Array,
      default: null
    },
    gridHeightFile: {
      type: Number,
      default: 210
    },
    parentKey: {
      type: Number,
      default: null
    },
    selectedParent: {
      type: Object,
      default: null
    },
    fileType: { // 0:고객 1:채용 2:지원자
      type: Number,
      default: null
    }

  },
  components: {
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxScrolling
  },
  created () {

  },
  mounted () {
    this.gridHeight = (screen.height - 180) * 0.6
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isCRUDFile (e) {
      if (Object.keys(this.selectedParent).length === 0) return false

      return this.userInfo.permission === ConstDef.SYSTEM_ADMIN || this.selectedParent.컨설턴트 === this.userInfo.userId
    },
    onInitNewRowFile (row) {
      row.data.파일유형 = this.fileType
      row.data.상위코드 = this.parentKey
      row.data.createdTime = this.$_appLib.getNow()
      row.data.createdId = row.data.updatedId = this.userInfo.userId
    },
    onFileChange ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let fileType = $event.target.name
      const form = new FormData()
      const file = $event.target.files[0]
      form.append('file', file)
      form.append('seqId', this.selectedRowFile.seqId)
      form.append('savedFile', this.selectedRowFile.저장파일명)
      form.append('fileType', fileType)
      this.$Q('#file-upload-input').val('')
      let url = '/attachedFileoUpload'
      FileService.upload(form, url)
        .then((data) => {
          console.log(data)
          if (data.RESULT === ConstDef.SUCCESS) {
            this.selectedRowFile.첨부파일명 = data.ORG_FILE_NAME
            this.selectedRowFile.저장파일명 = data.SAVED_FILE
            this.selectedRowFile.updatedId = this.userInfo.userId
            this.$_sp.runUpdateSqlProc('첨부파일정보', ['seqId'], null, [this.selectedRowFile])
              .then(data => {
                this.$snotify.info('저장 되었습니다.')
                this.$refs.refFileControl.instance.refresh()
              })
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR || error.response.status === ConstDef.NOT_ACCEPTABLE) {
            this.$snotify.error(error.response.data.message, { timeout: 0 })
          }
        })
    },
    onFocusedRowChangedFile (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowFile = e.row.data
        console.log('onFocusedRowChangedFile', this.selectedRowFile)
      }
    },
    onRowInsertedFile (row) {
      this.$_sp.runInsertAndFindSqlProc('첨부파일정보', ['파일유형', '첨부파일유형', 'createdTime'], ['seqId'], row.data)
        .then(data => {
          row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          this.focusedRowKeyFile = row.data.seqId
          this.selectedRowFile = row.data
          console.log(this.focusedRowKeyFile)
          this.$Q('#file-upload-input').click()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInsertingFile (row) {

    },
    onRowRemovedFile (row) {
      HttpService.reqPostBody({ fileName: row.data.저장파일명 }, '/deleteFile')
        .then(data => {
          if (data.RESULT === ConstDef.SUCCESS) {
            this.$_sp.runDeleteSqlProc('첨부파일정보', [{ seqId: row.data.seqId }])
              .then(data => {
                this.$snotify.info('삭제 되었습니다.')
              })
              .catch(error => {
                this.isLoading = false
                if (error.response.status === ConstDef.GENERRAL_ERROR) {
                  this.$snotify.error(error.response.data.message)
                } else {
                  this.$snotify.error(`에러코드 : ${error.response.status}`)
                }
              })
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparingFile (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'upload',
            hint: '파일업로드',
            text: '선택행 파일업로드',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              if (!this.isCRUDFile) {
                this.$snotify.info('파일 업로드 권한이 없습니다.')
                return
              }
              if (this.selectedRowFile === null) {
                this.$snotify.info('선택된 파일정보가 없습니다.')
                return
              }
              this.$Q('#file-upload-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'download',
            hint: '파일다운로드',
            text: '선택행 파일다운로드',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedRowFile === null) {
                this.$snotify.info('선택된 파일정보가 없습니다.')
                return
              }
              this.isLoading = true
              FileService.downloadFileWithParam(this.selectedRowFile.저장파일명, '/fileDownload', this.selectedRowFile.첨부파일명)
                .then((data) => {
                  this.isLoading = false
                })
                .catch(error => {
                  this.isLoading = false
                  console.log(error)
                  if (error.response.status === ConstDef.GENERRAL_ERROR) {
                    this.$snotify.error(error.response.data.message)
                  } else {
                    this.$snotify.error(`에러코드 : ${error.response.status}`)
                  }
                })
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'plus',
            hint: '새파일 업로드',
            text: '새파일 업로드',
            type: 'danger',
            focusStateEnabled: true,
            onClick: (args) => {
              if (Object.keys(this.selectedParent).length === 0) {
                this.$snotify.info('선택된 상위 정보가 없습니다.')
                return
              }
              if (!this.isCRUDFile) {
                this.$snotify.info('파일 업로드 권한이 없습니다.')
                return
              }
              this.$refs.refFileControl.instance.addRow()
            }
          }
        }

      )
    }

  }
}
</script>

<style lang="scss">

</style>
